"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridSelectionSubheaderValueHighlighted = exports.StyledGridSelectionSubheaderValue = exports.StyledGridSelectionSubheader = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const sizing_1 = require("../../../../../design/constants/sizing");
const typo_1 = require("../../../../../design/constants/typo");
const base_1 = require("../../../../../design/themes/base");
exports.StyledGridSelectionSubheader = styled_components_1.default.div `
    flex-shrink: 0;
    display: flex;
    box-sizing: border-box;
    align-self: stretch;
    align-items: center;
    background-color: ${base_1.baseTheme.colorBackgroundBlank.var()};
    height: ${sizing_1.sizing.sizeSpaceXL.var()};
    border-bottom: 1px solid ${base_1.baseTheme.colorBorderGrid.var()};
    padding: 0 ${sizing_1.sizing.sizeSpaceS.var()};
    font: ${typo_1.typo.typoFontMain.var()};
    color: ${base_1.baseTheme.colorTextSecondary.var()};
`;
exports.StyledGridSelectionSubheaderValue = styled_components_1.default.span `
    font: ${typo_1.typo.typoFontMain.var()};
    color: ${base_1.baseTheme.colorTextSecondary.var()};
    margin-left: ${sizing_1.sizing.sizeSpaceS.var()};
`;
exports.StyledGridSelectionSubheaderValueHighlighted = styled_components_1.default.span `
  ${({ selected }) => selected &&
    (0, styled_components_1.css) `
          font: ${typo_1.typo.typoFontMainSemiBold.var()};
          color: ${base_1.baseTheme.colorTextMain.var()};
      `}}
`;
//# sourceMappingURL=GridSelectionSubheader.styles.js.map